<template>
  <div>
    <div class="auth-area">
      <div class="auth-window">
        <div class="auth-logo">
          <img :src="logoUrl" alt="Widget Brain logo">
        </div>
        <form @submit.prevent="resetPassword" class="auth-form">

          <md-input-container md-has-password>
            <label>Password</label>
            <md-input type="password" v-model="password"></md-input>
          </md-input-container>

          <md-input-container md-has-password>
            <label>Repeat password</label>
            <md-input type="password" v-model="passwordRepeat"></md-input>
          </md-input-container>

          <div v-if="requirements && requirements.length > 0">
            <ul class="errors-list">
              <li v-for="requirement in requirements">
                {{requirement}}
              </li>
            </ul>
          </div>

          <div class="auth-actions">
            <md-button type="submit" @submit="resetPassword" class="md-raised md-primary" :disabled="!password || !!requirements.length">Reset pw</md-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import managedata from '../helpers/managedata';
import logoUrl from '../../images/logo.svg';

export default {
  name: 'PasswordChange',
  data() {
    return {
        logoUrl: logoUrl,
        password: '',
        passwordRepeat: '',
        requirements: [],
    }
  },
  methods: {
    checkPassword() {
      managedata.validatePassword(this.password)
        .then(res => {
          if (res.body.result.requirements && res.body.result.requirements.length > 0) {
            this.requirements = res.body.result.requirements;
          } else {
            this.requirements = [];
          }

          if (this.password !== this.passwordRepeat) {
              this.requirements.push('Passwords should match');
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    resetPassword() {
        console.log('reset', this.requirements , this.password !== this.passwordRepeat)
      if (this.password !== this.passwordRepeat) return;
      this.$store.dispatch('resetPassword', {pw: this.password, token: this.$route.query.access_token});
    }
  },
  watch: {
      password() {
          this.checkPassword();
      },
      passwordRepeat() {
          this.checkPassword();
      },
  },
}
</script>

<style scoped>
  .errors-list {
    list-style-type: none;
    padding-left: 0;
  }

  .errors-list li {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// PasswordChange.vue?244f6a2e